// Route guard for owner/admin-only tenant surfaces (Configuración, Agentes).
// These are hidden from the nav for agents/viewers; this also redirects a
// deep-linked URL back to Inicio. Defense in depth only — the API enforces
// every write server-side regardless of what the UI shows.

import { Navigate, Outlet } from 'react-router-dom'

import { useSession } from '../../auth/session.js'

export function RequireManage(): JSX.Element {
  const session = useSession()
  if (session === null) return <Navigate to="/login" replace />
  if (!session.canManageWorkspace) return <Navigate to="/home" replace />
  return <Outlet />
}
